export default __webpack_public_path__ + "ff179bc36928a31cc0062ab66671a7b5.png";